import script from "./Purpose.vue?vue&type=script&setup=true&lang=js"
export * from "./Purpose.vue?vue&type=script&setup=true&lang=js"

import "./Purpose.vue?vue&type=style&index=0&id=560cfbc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560cfbc1"]])

export default __exports__